import { get } from 'lodash';
import { RootState } from 'store';
import { useAppSelector } from 'store/hooks';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import { AuthStatus, IUserInfo } from '../interfaces/api';

type MyState = RootState['auth'];
const getCurrentState = (state: RootState): MyState => state['auth'];

const selector = <T = MyState>(key: keyof T, defaultValue?: any) => useAppSelector(state => get(getCurrentState(state), key, defaultValue));

const getDemoData = () => selector('demoData') as IDEMOModelResDataItem[];
const getUser = () => selector('user') as IUserInfo | null;
const getStatus = () => selector('status') as AuthStatus;
const getErrorMessage = () => selector('errorMessage') as string | null;
const isAuthenticated = () => selector('status') === 'authenticated';
const isLoading = () => selector('status') === 'loading';

const authSelectors = {
  getDemoData,
  getUser,
  getStatus,
  getErrorMessage,
  isAuthenticated,
  isLoading,
};
export default authSelectors;
